module.exports = __webpack_public_path__ + "img/cicc.796deb8f.jpg";